import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { FlowProvider } from './state/FlowContext';
import './i18n';
import './styles/global.scss';

// The flow only makes sense starting at `/`. If a visitor lands anywhere
// else on a hard load (refresh on /share, deep link, browser-restored tab),
// rewrite the URL to `/` before the router boots so React never sees the
// stale entry. `/debug/*` is exempt so the QA grid can be opened directly.
const entryPath = window.location.pathname;
if (entryPath !== '/' && !entryPath.startsWith('/debug')) {
  window.history.replaceState(null, '', '/');
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root missing from index.html');

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <FlowProvider>
        <App />
      </FlowProvider>
    </BrowserRouter>
  </StrictMode>,
);
